import { IS_MOBILE_DEVICE } from "../globals";

export default class Video {

    static initAll() {
        return new Video();
    }

    constructor() {
        // all videos with controls enabled
        const videos = document.querySelectorAll('.video-player video[controls]');

        if (videos.length === 0)
            return;

        videos.forEach((video) => {
            const playButton = video.parentElement.querySelector('.button-play');

            if (!playButton)
                return;

            if (IS_MOBILE_DEVICE) {
                playButton.remove();
                return;
            }
            
            video.removeAttribute('controls');

            playButton.addEventListener('click', () => {
                video.play();
            });

            video.addEventListener('play', () => {
                video.setAttribute('controls', 'true');
                playButton.remove();
            });
        });
    }
}